import { useMemo } from 'react';

import { useWindow } from '@src/contexts/window-context';

type UseDesignTokenHook = (cssVariableName: string, type: 'number' | 'string') => number | string | undefined;

export const useDesignToken: UseDesignTokenHook = (cssVariableName, type) => {
  const { width } = useWindow();

  return useMemo(() => {
    if (!width) {
      return undefined;
    }

    const computedStyle = getComputedStyle(document.documentElement);
    const propertyValue = computedStyle.getPropertyValue(cssVariableName);

    if (type === 'number') {
      return parseInt(propertyValue, 10);
    }

    return propertyValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);
};
